<template>
  <v-simple-table style="background-color: #fff !important;">
    <template v-slot:default>
      <thead>
      <tr>
        <th class="text-left">Nº Presupuesto</th>
        <th class="text-left">Nombre</th>
        <th class="text-left">Fecha</th>
        <th class="text-left">Cantidad</th>
        <th class="text-left">Estado</th>
        <th class="text-left">Acciones</th>
        <th class="text-left">Ver PDF</th>
      </tr>
      </thead>
      <tbody>
      <tr v-for="budget in budgets" :key="budget.projectID">
        <td>
          <p v-if="budget.projectID<10"> 0000000{{ budget.projectID }}/{{ budget.date_add.split("-")[0] }}</p>
          <p v-if="budget.projectID<100 && budget.projectID>=10">
            000000{{ budget.projectID }}/{{ budget.date_add.split("-")[0] }}</p>
          <p v-if="budget.projectID<1000 && budget.projectID>=109">
            00000{{ budget.projectID }}/{{ budget.date_add.split("-")[0] }}</p>
        </td>
        <td>{{ budget.name }}</td>
        <td>{{ budget.date_add }}</td>
        <td>{{ getParseTotal(budget.total_end) }}€</td>
        <td v-if="budget.status==='0'" style="color:#E8AD00">Pendiente de confirmación
        </td>
        <td v-else-if="budget.status==='1'" style="color:#217A2B">Aceptado</td>
        <td v-else-if="budget.status==='2'" style="color:#42A5F5">Facturado</td>

        <td v-else-if="budget.status==='4'" style="color:red">Rechazado</td>
        <td>
          <v-btn
              v-if="budget.status==='0'"
              color="green lighten-3"
              class="ma-2 white--text"
              outlined
              @click="acceptBudget(budget.budgetID)">
            Aceptar
            <v-icon right dark>mdi-check</v-icon>
          </v-btn>
          <v-btn
              v-if="budget.status==='0'"
              color="red lighten-3"
              class="ma-2 white--text"
              outlined
              @click="deniedBudget(budget.budgetID)">
            Rechazar
            <v-icon right dark>mdi-close</v-icon>
          </v-btn>
          <v-btn
              v-if="budget.status==='1'"
              color="blue lighten-1"
              class="ma-2 white--text"
              outlined>
            Generar Contrato
            <v-icon right dark>mdi-file-document</v-icon>
          </v-btn>
          <v-btn
              v-if="budget.status==='1'"
              color="blue lighten-1"
              class="ma-2 white--text"
              outlined>
            Generar Factura
            <v-icon right dark>mdi-file-document</v-icon>
          </v-btn>
        </td>
        <td><a :href="'https://invoicer.grupowapps.es/generator/budget/'+budget.budgetID+'/'+$route.params.id"
               target="_blank" rel="nofollow">
          <v-icon>mdi-file-pdf</v-icon>
        </a></td>
      </tr>
      </tbody>
    </template>
  </v-simple-table>
</template>

<script>
export default {
  name: "budgetsTable",
  props: ['budgets', 'refresh'],
  methods: {
    getParseTotal(total) {
      return parseFloat(total).toFixed(2)
    },
    acceptBudget(bid) {
      this.loaded = false;
      let url = this.base_url + '/api2/newAdmin/updatebudget';
      let formData = new FormData();
      formData.set('token', localStorage.token);
      formData.set('budgetID', bid);
      formData.set('status', 1);
      this.axios.post(url, formData).then(() => {
        this.refresh();
      });
    },
    deniedBudget(bid) {
      this.loaded = false;
      let url = this.base_url + '/api2/newAdmin/updatebudget';
      let formData = new FormData();
      formData.set('token', localStorage.token);
      formData.set('budgetID', bid);
      formData.set('status', 4);
      this.axios.post(url, formData).then(() => {
        this.refresh();
      });
    }
  }
}
</script>

<style scoped>

</style>